import { useState } from "react";
import { api, formatApiErrorDetail } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setMsg(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "Se o e-mail existir, enviaremos instruções.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-wrap">
      <aside className="auth-side">
        <div>
          <div className="brand-box"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
          <h1>Recuperar acesso</h1>
          <p>Informe seu e-mail e enviaremos um link para redefinir sua senha com segurança.</p>
        </div>
        <div className="foot">RotaSaúde SaaS</div>
      </aside>
      <div className="auth-panel">
        <form className="auth-card" onSubmit={submit}>
          <div className="mobile-logo"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
          <h2>Esqueci minha senha</h2>
          <p className="sub">Enviaremos instruções de redefinição.</p>
          {error && <div className="auth-error">{error}</div>}
          {msg && <div className="auth-ok" data-testid="forgot-ok">{msg}</div>}
          <label className="auth-field">E-mail
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <button className="auth-btn" disabled={loading} data-testid="forgot-submit">{loading ? "Enviando…" : "Enviar link"}</button>
          <div className="auth-toggle"><a href="/login">Voltar ao login</a></div>
        </form>
      </div>
    </div>
  );
}
